import client from '../../client';

export default async function file(
  formId: string,
  recordId: string,
  src: string,
  title: string
): Promise<unknown> {
  const { data } = await client.post('/form/upload/files', {
    formId,
    recordId,
    files: [{ src, title }],
  });

  return data[0];
}
